import { observer } from 'mobx-react-lite'
import { Alert, Box, Button, Icon, Typography } from 'shared/ui'
import { DropdownCards } from 'entities/Billing/ui/DropdownCards'
import { useCreateContext } from 'pages/clients/pages/create/context/createContext'
import styles from './styles.module.scss'

export const FranchisePlanSummary = observer(() => {
  const {
    choosePlanStore,
    isInviteLoading,
    isPaymentError,
    handleInviteClient,
    dropdownCardsStore,
  } = useCreateContext()
  const { franchisePlanInfo } = choosePlanStore

  if (!franchisePlanInfo) return null

  const { name, credits, additionalCreditPrice, seats, totalPrice, isAnnual } = franchisePlanInfo
  const creditsLabel = `${Intl.NumberFormat('en').format(credits)} credits / ${
    isAnnual ? 'year' : 'month'
  }`
  const additionalCreditLabel = `$${additionalCreditPrice} per additional credit`

  return (
    <>
      {isPaymentError && (
        <Alert
          item={{
            type: 'error',
            title: 'We were unable to process your payment',
            desc: 'Please select a different card',
          }}
          marginBottom={16}
        />
      )}
      <div className={styles.planHeader}>
        <div className={styles.planHeaderTitle}>
          <Icon icon={'diamond'} color={'var(--green-70)'} fontSize={24} />
          <Typography ariaLabel={'franchise-plan-name'} variant={'body-lg-medium'}>
            {name}
          </Typography>
        </div>
        <Box display={'flex'} flexDirection={'column'} gap={1}>
          <Typography ariaLabel={'franchise-credits'} variant={'body-md-regular'}>
            {creditsLabel}
          </Typography>
          <Typography ariaLabel={'franchise-additional-credit'} variant={'body-md-regular'}>
            {additionalCreditLabel}
          </Typography>
          <Typography ariaLabel={'franchise-seats'} variant={'body-md-regular'}>
            {`Seats × ${seats}`}
          </Typography>
        </Box>
      </div>
      <div className={styles.planTotal}>
        <Typography ariaLabel={'TotalDueTodayTitle'} variant={'body-lg-medium'}>
          Total due today
        </Typography>
        <Typography ariaLabel={'TotalDueTodayValue'} variant={'body-lg-medium'}>
          {totalPrice}
        </Typography>
      </div>
      <DropdownCards store={dropdownCardsStore} />
      <Alert
        item={{
          type: 'warning',
          desc: 'For franchise accounts, payment is requested from the franchise when the invite is sent, or from the client when they activate their account — depending on who is set to pay.',
        }}
        marginBottom={32}
        marginTop={32}
      />
      <Button
        fullWidth
        text={'Create client'}
        typeBtn={'contained'}
        contained={'primary'}
        size={'extraLarge'}
        intent={'positive'}
        className={styles.createButton}
        onClick={handleInviteClient}
        disabled={isInviteLoading}
        loading={isInviteLoading}
      />
    </>
  )
})
